/**
 * EventEntityDefaultVarietyName
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import EntityDefaultVarietyName from '../EntityDefaultVarietyName';

// Selectors
import { makeSelectEventValue } from '../../services/events/selectors';

interface Props {
    entityId?: string;
}

export class EventEntityDefaultVarietyName extends React.PureComponent<Props> {
    render() {
        const { entityId } = this.props;
        return <EntityDefaultVarietyName entityId={entityId} />;
    }
}

const mapStateToProps = createStructuredSelector({
    entityId: makeSelectEventValue('entityId')
});

export default connect(mapStateToProps)(EventEntityDefaultVarietyName);
